import React from "react";
import { ItemsTable } from "../accounting/entry/ItemsTable.js";
import { useTemplate } from "./TemplateProvider.js";

/**
 * Renders table with template entry items.
 */
export const TemplateEntry = () => {
  const { entry } = useTemplate();
  if (!entry) {
    return null;
  }

  return <ItemsTable entry={entry} />;
};
